var time;

$(document).on("click", ".js-remove-button", function (e) {

  //e.preventDefault();
  e.stopPropagation();

  clearTimeout(time);
  let btn = $(this);
  let initialText = '<i class="fa fa-trash"></i>';
  let questionText = "Are you sure?";

  time = setTimeout(function () {
    btn.html(initialText);
    if (btn.hasClass("deleteServiceTypeBtn")) {
      btn.removeClass("deleteServiceTypeBtn");
    }
    else if(btn.hasClass("deleteSurchargeBtn")){
      btn.removeClass("deleteSurchargeBtn");
    }
    else if(btn.hasClass("deleteZoneBtn")){
      btn.removeClass("deleteZoneBtn");
    }
  }, 6000);

  if ($(this).html() === initialText) {
    if ($(this).attr("data-id") === "deleteServiceTypeBtn") {
      $(this).addClass("deleteServiceTypeBtn");
      $(this).html(questionText);
    } else if($(this).attr("data-id") === "deleteSurchargeBtn"){
      $(this).addClass("deleteSurchargeBtn");
      $(this).html(questionText);
    } else if($(this).attr("data-id") === "deleteZoneBtn"){
      $(this).addClass("deleteZoneBtn");
      $(this).html(questionText);
    } else {
      $(this).attr("id", $(this).attr("data-id"));
    }
  } else {
    if ($(this).hasClass("deleteServiceTypeBtn")) {
      $(this).removeClass("deleteServiceTypeBtn");
    }
    $(this).attr("id", "");
    $(this).html(initialText);
  }
});
